module.exports = __webpack_public_path__ + "images/namsosinternational_smalled6d252a675930c6259be04711218285.png";